module.exports = __webpack_public_path__ + "static/media/preview-logo-bleu-a.6e40ed10.png";